import React from 'react';

interface LogoProps {
  size?: 'sm' | 'lg';
  className?: string;
  alt?: string;
}

/**
 * Logo component that displays the company logo
 * Supports small and large sizes with customizable styling
 */
export const Logo: React.FC<LogoProps> = ({ 
  size = 'lg', 
  className = '', 
  alt = 'Terretech' 
}) => {
  const logoSrc = size === 'sm' ? '/ioh-sm-logo.png' : '/ioh-lg-logo.png';
  const defaultClass = size === 'sm' ? 'h-8 w-8' : 'h-10 w-auto';

  return (
    <img 
      src={logoSrc}
      alt={alt}
      className={`${defaultClass} ${className}`}
      loading="lazy"
      decoding="async"
    />
  );
};
